import { useCallback, useContext, useMemo } from 'react'
import { useIntl } from 'react-intl'
import BodyText from 'LuxKit/Typography/BodyText'
import LandingPageLoyaltyBenefitTile from './LandingPageLoyaltyBenefitTile'
import LandingPageLoyaltyExclusiveSavingsModal from './LandingPageLoyaltyExclusiveSavingsModal'
import ModalContext from 'contexts/ModalContext'
import { MALDIVES_MARKETING_BANNER_IMAGE_ID } from 'constants/charterFlight'

interface Props {
  layout: 'tile' | 'row'
}

function LandingPageLoyaltyExclusiveSavings(props: Props) {
  const { layout } = props
  const intl = useIntl()
  const showModal = useContext(ModalContext)

  const image = useMemo<App.Image>(() => ({
    id: MALDIVES_MARKETING_BANNER_IMAGE_ID,
    title: intl.formatMessage({
      id: 'IE6SRQh6pFzvxwKoBXuh',
      defaultMessage: 'Aerial view of overwater villas in the Maldives',
      description: 'Alternative text for the hero image in the Infinite exclusive savings benefit modal',
    }),
  }), [intl])

  const handleDetailsClick = useCallback(() => {
    showModal(<LandingPageLoyaltyExclusiveSavingsModal image={image} />)
  }, [image, showModal])

  return <LandingPageLoyaltyBenefitTile
    layout={layout}
    benefitType="family_and_friends_access"
    heading={intl.formatMessage({
      id: 'pezwI9oyKQUq8WKmMrmj',
      defaultMessage: 'Access to exclusive savings',
      description: 'Heading for the Infinite member benefit tile granting access to exclusive savings and offers',
    })}
    subtitle={<BodyText variant="small">{intl.formatMessage({
      id: '4USqW09Gx5p1PPMzZDEL',
      defaultMessage: 'Including our direct Maldives charter flights, with priority upgrades',
      description: 'Subtitle for the Infinite exclusive savings benefit tile describing direct Maldives charter flight access',
    })}
    </BodyText>}
    onClick={handleDetailsClick}
  />
}

export default LandingPageLoyaltyExclusiveSavings
